// src/design/tokens.ts
// TS-Pendant zu tokens.css, fuer Inline-Styles/Komponentenlogik (z. B.
// src/core/score/dealScoreBadges.ts). tokens.css ist die Quelle der Wahrheit
// (1:1-Kopie aus propora-design-kit/design/tokens.css, siehe dort) -- diese
// Datei haelt dieselben Werte von Hand synchron, kein Build-Schritt generiert
// sie. Bei einer Aenderung an tokens.css: hier nachziehen.
//
// Gilt nur fuer neue Screens (src/design/**). theme.ts (bestehende dunkle
// Analyzer-Screens) bleibt unveraendert und unabhaengig davon.

export const colors = {
  paper: "#f5f3ea",
  forest: "#244737",
  forestDeep: "#193c2f",
  sage: "#cbd5bd",
  sageSoft: "#e9eddf",
  lime: "#ddf2a2",
  ink: "#173d30",
  muted: "#5e6d60",
  line: "#d4d9ca",
  lineDark: "#657d69",
  white: "#fffdf8",
  negative: "#a14e37",
  negativeOnDark: "#f0a68a",
  positiveOnDark: "#ddf2a2",
} as const;

export const font = {
  family: "'Inter', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  // Nur die Schnitte, die tatsaechlich eingebunden sind (src/design/fonts.css): 400/500/600.
  weight: { regular: 400, medium: 500, semibold: 600 } as const,
  size: {
    display: "clamp(2.375rem, 5.6vw, 5rem)",
    heading: "clamp(1.875rem, 3.1vw, 3rem)",
    subheading: "clamp(1.125rem, 1.5vw, 1.375rem)",
    body: "clamp(1rem, 1.2vw, 1.125rem)",
    small: ".8125rem",
    label: ".75rem",
  },
  leading: { display: 1.04, heading: 1.12, body: 1.6 },
  tracking: { display: "-.045em", heading: "-.03em", label: ".13em" },
} as const;

export const space = {
  contentMax: "80rem",
  pageGutter: "clamp(1.25rem, 3.3vw, 3rem)",
  sectionSpace: "clamp(3rem, 5.5vw, 6rem)",
  s1: ".25rem",
  s2: ".5rem",
  s3: ".75rem",
  s4: "1rem",
  s6: "1.5rem",
  s8: "2rem",
  s12: "3rem",
} as const;

export const radius = {
  action: ".375rem",
  surface: ".5rem",
} as const;

export const motion = {
  durationFast: "160ms",
  durationValue: "240ms",
  durationScene: "720ms",
  ease: "cubic-bezier(.22, 1, .36, 1)",
} as const;

/** `font-variant-numeric: tabular-nums` fuer Zahlen (Score, Kennzahlen) -- siehe Spezifikation. */
export const tabularNums = { fontVariantNumeric: "tabular-nums" } as const;
